// src/util/getElementName.ts
var getElementName = function getElementName(element) {
  var _a, _b;
  var elementName =
  // @ts-ignore
  ((_a = element == null ? void 0 : element.target) == null ? void 0 : _a.displayName) || (
  // @ts-ignore
  (_b = element == null ? void 0 : element.type) == null ? void 0 : _b.displayName) || (element == null ? void 0 : element.type);
  return typeof elementName === "string" ? elementName : null;
};
export { getElementName };